
/**
 * @export
 * @enum {string}
 */
export enum SearchSettingsType {
    COMPANY = 'COMPANY',
    INVESTOR = 'INVESTOR',
    SP = 'SP',
    LP = 'LP',
    PERSON = 'PERSON'
}